import gql from 'graphql-tag';

const DEVICE_DATA = gql`
  query Query($deviceSerialNo: String!, $to: Date, $from: Date, $sensor: String!) {
    deviceData(deviceSerialNo: $deviceSerialNo, to: $to, from: $from, sensor: $sensor) {
      id_wasp
      sensor
      value
      datetime
      from
    }
  }
`;

export default DEVICE_DATA;
